'use client';

import type { Template } from '@packages/modules/src/helpers/getResponsiveAkamaiTemplate/types';
import { Image } from '@packages/shared/src/ui/Image/Image';
import { useIsDialogOpen } from '../ImageGalleryProvider/ImageGalleryProvider.client';
import { type RawProductData } from '../../../types';

type ImageGalleryImageProps = {
  url: RawProductData['media'][number]['url'];
  name: RawProductData['name'];
  isFirstImage?: boolean;
  template: Template['templateName'];
};

/**
 * ImageGalleryImageWrapper is a wrapper component that exists as a client component
 * to wrap the image and handle the click event for opening the image gallery dialog.
 * You can pass a server component as a child to this wrapper.
 */
export const ImageGalleryImage = ({
  url,
  name,
  isFirstImage,
  template,
}: ImageGalleryImageProps) => {
  const [, setIsDialogOpen] = useIsDialogOpen();

  return (
    <button className="cursor-pointer" onClick={() => setIsDialogOpen(true)} type="button">
      <Image
        src={`${url}?${template}`}
        alt={name}
        fill
        className="object-contain"
        priority={isFirstImage}
        fetchPriority={isFirstImage ? 'high' : 'low'}
        loading={isFirstImage ? 'eager' : 'lazy'}
        noLoader={isFirstImage}
      />
    </button>
  );
};
